import { SvgTokenIcons } from './index.es.js';

const TokenIconNameAliases = {
    SONIC: SvgTokenIcons.S,
    WORLDCHAIN: SvgTokenIcons.WLD
};

export { TokenIconNameAliases };
//# sourceMappingURL=aliases.es.js.map
